import { useTranslation } from 'react-i18next';
import { 
  ClockIcon,
  UserGroupIcon,
  ChartBarIcon,
  DevicePhoneMobileIcon,
  DocumentCheckIcon,
  CogIcon,
  CircleStackIcon,
  CreditCardIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';

const iconClasses = 'w-12 h-12 text-[#ff5f00] mb-4';

export default function Features() {
  const { t } = useTranslation();

  const features = [
    { icon: <ClockIcon className={iconClasses} />, key: 'timeTracking' },
    { icon: <UserGroupIcon className={iconClasses} />, key: 'management' },
    { icon: <CogIcon className={iconClasses} />, key: 'reports' },
    { icon: <DevicePhoneMobileIcon className={iconClasses} />, key: 'mobile' },
    { icon: <DocumentCheckIcon className={iconClasses} />, key: 'compliance' },
    { icon: <ChartBarIcon className={iconClasses} />, key: 'integration' },
    { icon: <CircleStackIcon className={iconClasses} />, key: 'backup' },
    { icon: <CreditCardIcon className={iconClasses} />, key: 'NFC' },
    { icon: <MapPinIcon className={iconClasses} />, key: 'location' }
  ];

  return (
    <section 
      id="features" 
      className="py-20 relative bg-fixed bg-cover bg-center"
      style={{
        backgroundImage: 'url(/images/temp/slide1.jpg)',
      }}
    >
      {/* Overlay oscuro */}
      <div className="absolute inset-0 z-0 bg-black/50"></div>
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-4xl font-bold text-center mb-16 text-white">{t('features.title')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div key={feature.key} className="bg-white/90 backdrop-blur-sm p-8 rounded-lg shadow-sm hover:shadow-md transition-all hover:bg-white/100">
              <div className="flex flex-col items-center text-center">
                {feature.icon}
                <h3 className="text-xl font-semibold mb-4">
                  {t(`features.${feature.key}.title`)}
                </h3>
                <p className="text-gray-600">
                  {t(`features.${feature.key}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
